import { render, staticRenderFns } from "./ProjectSocialPlatformFacebook.vue?vue&type=template&id=e22ad020"
import script from "./ProjectSocialPlatformFacebook.vue?vue&type=script&lang=ts"
export * from "./ProjectSocialPlatformFacebook.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports